(function () {
  var GALLERY_SELECTOR = "#pwzrswiper-wrapper";
  var SLIDE_SELECTOR = ".pwzrswiper-slide";
  var TOOLTIP_CLASS = "ms-media-tooltip-container";

  function safeArray(v) {
    return Array.isArray(v) ? v : [];
  }

  function cleanAlt(alt) {
    // Optional: remove "Info:" prefix
    return (alt || "").toString().trim().replace(/^info:\s*/i, "");
  }

  function escapeHtml(str) {
    return (str || "").toString()
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  /* ============================
   Mobile tooltip toggle logic
   ============================ */
  function isTouchDevice() {
    return window.matchMedia &&
          window.matchMedia("(hover: none) and (pointer: coarse)").matches;
  }

  function bindMobileTooltipToggle() {
    if (!isTouchDevice()) return;

    // Toggle tooltip on title tap
    document.addEventListener("click", function (e) {
      var title = e.target.closest(".ms-media-tooltip-title");
      if (!title) return;

      var container = title.closest(".ms-media-tooltip-container");
      if (!container) return;

      // Close other open tooltips (optional but recommended)
      document.querySelectorAll(".ms-media-tooltip-container.is-open")
        .forEach(function (el) {
          if (el !== container) el.classList.remove("is-open");
        });

      // Toggle current
      container.classList.toggle("is-open");

      e.preventDefault();
      e.stopPropagation();
    });

    // Close when tapping outside
    document.addEventListener("click", function (e) {
      if (e.target.closest(".ms-media-tooltip-container")) return;

      document.querySelectorAll(".ms-media-tooltip-container.is-open")
        .forEach(function (el) {
          el.classList.remove("is-open");
        });
    });

    // Close on scroll (mobile UX)
    document.addEventListener("scroll", function () {
      document.querySelectorAll(".ms-media-tooltip-container.is-open")
        .forEach(function (el) {
          el.classList.remove("is-open");
        });
    }, { passive: true });
  }

  function hasTooltipAlready(slide) {
    return !!slide.querySelector("." + TOOLTIP_CLASS);
  }

  function createTooltipNode(title, content) {
    var el = document.createElement("div");
    el.className = TOOLTIP_CLASS;
    el.innerHTML = `
      <div class="ms-media-tooltip-content">${escapeHtml(content)}</div>
      <div class="ms-media-tooltip-title">
        <span>${escapeHtml(title)}</span>
        <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <circle cx="10" cy="10" r="10" fill="#5c5c5c"></circle>
          <path d="M8.93359 3.25977C8.93359 2.8431 9.05729 2.51107 9.30469 2.26367C9.55859 2.01628 9.88086 1.89258 10.2715 1.89258C10.4668 1.89258 10.6458 1.92513 10.8086 1.99023C10.9714 2.05534 11.1113 2.14648 11.2285 2.26367C11.3457 2.38086 11.4368 2.52409 11.502 2.69336C11.5736 2.86263 11.6094 3.05143 11.6094 3.25977C11.6094 3.45508 11.5736 3.63737 11.502 3.80664C11.4368 3.9694 11.3457 4.11263 11.2285 4.23633C11.1113 4.35352 10.9714 4.44466 10.8086 4.50977C10.6458 4.57487 10.4668 4.60742 10.2715 4.60742C10.0762 4.60742 9.89714 4.57487 9.73438 4.50977C9.57161 4.44466 9.42839 4.35352 9.30469 4.23633C9.1875 4.11263 9.09635 3.9694 9.03125 3.80664C8.96615 3.63737 8.93359 3.45508 8.93359 3.25977ZM12.9961 16.8926C12.6576 16.9772 12.2734 17.0358 11.8438 17.0684C11.4141 17.1074 10.9355 17.127 10.4082 17.127C10.265 17.127 10.1185 17.1139 9.96875 17.0879C9.82552 17.0684 9.69531 17.0293 9.57812 16.9707C9.46094 16.9056 9.36328 16.821 9.28516 16.7168C9.21354 16.6061 9.17773 16.4629 9.17773 16.2871C9.17773 15.9681 9.1875 15.6523 9.20703 15.3398C9.23307 15.0273 9.24609 14.666 9.24609 14.2559V8.77734C9.24609 8.64714 9.23958 8.51367 9.22656 8.37695C9.22005 8.24023 9.20378 8.11654 9.17773 8.00586C8.94336 7.9082 8.66341 7.85938 8.33789 7.85938H7.39062V6.92188C7.46875 6.90234 7.58919 6.88281 7.75195 6.86328C7.92122 6.83724 8.11003 6.81445 8.31836 6.79492C8.5332 6.77539 8.76432 6.75911 9.01172 6.74609C9.25911 6.73307 9.50651 6.72656 9.75391 6.72656C10.0664 6.72656 10.3594 6.74284 10.6328 6.77539C10.9128 6.80143 11.1439 6.85026 11.3262 6.92188V14.373C11.3262 14.7441 11.3424 15.0632 11.375 15.3301C11.4076 15.5905 11.4466 15.8184 11.4922 16.0137H12.8984L12.9961 16.8926Z" fill="white"></path>
        </svg>
      </div>
    `;
    return el;
  }

  function normalizeUrlKey(url) {
  var u = (url || "").toString().split("?")[0].trim();
  u = u.replace(/^https?:\/\//i, "//");
  return u;
}

function normalizeMapKeys(map) {
  var out = {};
  Object.keys(map || {}).forEach(function (k) {
    out[normalizeUrlKey(k)] = map[k];
  });
  return out;
}

function applyTooltips(wrapper) {
  if (!wrapper) return;

  var rawMap = window.msMediaTooltipMap || {};
  var map = normalizeMapKeys(rawMap);

  if (!map || Object.keys(map).length === 0) return;

  var slides = wrapper.querySelectorAll(".pwzrswiper-slide");
  if (!slides.length) return;

  slides.forEach(function (slide) {
    var img = slide.querySelector("img");
    if (!img) return;

    var alt = cleanAlt(img.getAttribute("alt"));
    if (!alt) return; // only images with alt text

    var srcKey = normalizeUrlKey(img.getAttribute("src") || "");
    var info = map[srcKey];

    // fallback if lazy-loaded
    if (!info) {
      srcKey = normalizeUrlKey(img.getAttribute("data-src") || "");
      info = map[srcKey];
    }

    if (!info || !info.content) return;
    if (hasTooltipAlready(slide)) return;

    slide.appendChild(createTooltipNode(info.title || alt, info.content));
  });
}



  // Observe wrapper changes (app re-renders)
  function observeWrapper(wrapper) {
    var obs = new MutationObserver(function () {
      applyTooltips(wrapper);
    });
    obs.observe(wrapper, { childList: true, subtree: true });
  }

  // Wait until the app gallery exists
  function waitForGallery(timeoutMs) {
    return new Promise(function (resolve) {
      var start = Date.now();

      function check() {
        var wrapper = document.querySelector(GALLERY_SELECTOR);
        if (wrapper) return resolve(wrapper);
        if (Date.now() - start > timeoutMs) return resolve(null);
        requestAnimationFrame(check);
      }

      check();
    });
  }

  // Run apply multiple times (covers app re-render timing on variant change)
  function reapplyWithDelays() {
    var delays = [0, 150, 600, 1200];
    delays.forEach(function (ms) {
      setTimeout(function () {
        var wrapper = document.querySelector(GALLERY_SELECTOR);
        if (wrapper) applyTooltips(wrapper);
      }, ms);
    });
  }

  // Hook variant changes (theme events + fallback)
  function bindVariantEvents() {
    // Dawn + many themes:
    document.addEventListener("variant:changed", reapplyWithDelays);
    document.addEventListener("variant:change", reapplyWithDelays);

    // If your theme uses a web component variant picker:
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t) return;

      // common patterns
      if (
        t.matches('variant-radios input') ||
        t.matches('variant-selects select') ||
        t.closest('variant-radios') ||
        t.closest('variant-selects') ||
        t.name === "id" // variant id select
      ) {
        reapplyWithDelays();
      }
    });

    // Some themes dispatch custom events from product form:
    document.addEventListener("product:variant-change", reapplyWithDelays);
  }

  async function init() {
    // Wait for gallery to load (app renders after)
    var wrapper = await waitForGallery(20000);
    if (!wrapper) return;

    // Observe changes inside wrapper (images get replaced)
    observeWrapper(wrapper);

    // Initial apply + bind variant changes
    applyTooltips(wrapper);
    bindVariantEvents();

    bindMobileTooltipToggle();

    // Safety: run once more shortly after load
    reapplyWithDelays();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
